<template>
  <div>
    <b-navbar class="navbar" toggleable="lg" type="dark">
      <b-navbar-brand href="#" class="mb-4 mt-4">
        <router-link class="title-nav" to="/home" @click.native="selected = 0">
          <span>Danish Covid-19 Genome Consortium</span>

          <!-- <img
            src="@/../public/AAU_Logo.jpg"
            height="100px"
            class="d-inline-block align-top"
            alt="Aalborg University"
          />
          <img
            src="@/../public/SSI_Logo.png"
            style="padding-left: 40px; padding-top: 15px"
            height="80px"
            class="d-inline-block align-top"
            alt="Statens Serum Institut"
          /> -->
        </router-link>
      </b-navbar-brand>
      <b-navbar-toggle
        target="nav-collapse"
        class="bg-darker"
      ></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <router-link
            to="/home"
            @click.native="selected = 0"
            :class="{ selected: selected == 0 }"
            class="btn-nav"
            >HOME</router-link
          >
          <!-- <router-link
            to="/microreact"
            @click.native="selected = 1"
            :class="{ selected: selected == 1 }"
            class="btn-nav"
            >MICROREACT</router-link
          > -->
          <router-link
            to="/nextstrain"
            @click.native="selected = 1"
            :class="{ selected: selected == 1 }"
            class="btn-nav"
            >NEXTSTRAIN</router-link
          >
          <router-link
            to="/statistics"
            @click.native="click_statistics"
            :class="{ selected: selected == 2 }"
            class="btn-nav"
            >STATISTICS</router-link
          >
          <!-- <router-link
            to="/statistics"
            @click.native="selected = 2"
            :class="{ selected: selected == 2 }"
            class="btn-nav"
            >STATISTICS</router-link
          > -->
          <router-link
            to="/about"
            @click.native="selected = 3"
            class="btn-nav"
            :class="{ selected: selected == 3 }"
            >ABOUT US</router-link
          >
          <router-link
            to="/contact"
            @click.native="selected = 4"
            class="btn-nav"
            :class="{ selected: selected == 4 }"
            >CONTACT</router-link
          >
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <!-- <b-navbar-nav class="ml-auto">
          
        </b-navbar-nav>-->
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      selected: 0,
    }
  },
  methods:{
    click_statistics(){
      window.location.reload()
    }
  },
  mounted(){
    switch (this.$route.path) {
      case '/home': this.selected=0; break;
      // case '/microreact': this.selected=1;break;
      case '/nextstrain': this.selected=1; break;
      case '/statistics': this.selected=2; break;
      case '/about':this.selected=3; break;
      case '/contact':this.selected=4; break;
    }
  }
};
</script>

<style scoped>
.selected {
  border-bottom: 1px solid #090d54 !important;
}

.title-nav{
  color: #090d54;
  text-decoration: none;
  font-size: 3vh;
  font-family: Oswald;
}

@media only screen and (max-width: 400px) {
  .title-nav{
    color: #090d54;
    text-decoration: none;
    font-size: 2vh;
    font-family: Oswald;
  }
}

.btn-nav {
  color: #090d54;
  font-size: 120%;
  padding-left: 10px;
  padding-right: 10px;
  border: none;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;

  border-bottom: 1px solid white;
  transition: border-color 0.3s linear;
}

.btn-nav:hover {
  border-bottom: 1px solid rgba(9, 13, 84, 0.4);
}

.navbar {
  border-bottom: 1px solid #090d54;
}
</style>